module.exports = __webpack_public_path__ + "067a66d7385878d3781d12b0e97f106f.png";